module.exports = __webpack_public_path__ + "static/media/text-image.a7db49e9.png";